module.exports = __webpack_public_path__ + "static/media/iGotNothin.6db598ff.png";